import { Alert } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

type ManagingErrorParams = {
  theUserIsGood: {
    email: string;
    role: string | number | undefined;
    assignedGroups: number[];
    isTheassignedGroupsGood: boolean;
    isTheEmailOk: boolean;
    isTheEmailExist: boolean;
    istheRolOk: boolean;
    rowPosition: number;
  }[];
  tryingToCreateSomething: boolean;
};

export const ManagingError: FC<ManagingErrorParams> = ({
  theUserIsGood,
  tryingToCreateSomething,
}) => {
  const [t] = useTranslation("global");

  const encounterErrorEmail = theUserIsGood.filter(
    (rows) => rows.isTheEmailOk === false
  );
  const encounterErrorEmailExist = theUserIsGood.filter(
    (rows) => rows.isTheEmailExist === true
  );
  const encounterErrorSites = theUserIsGood.filter((rows) => false);
  const encounterErrorRoles = theUserIsGood.filter(
    (rows) => rows.istheRolOk === false
  );

  const emailErrors = () => {
    const resultsEmailErrors = encounterErrorEmail.map((results) => (
      <span key={results.rowPosition} className="mr-2">
        {encounterErrorEmail.length === 1
          ? `${results.rowPosition}`
          : `${results.rowPosition},`}
      </span>
    ));

    return (
      <div>
        {resultsEmailErrors.length >= 1 ? (
          <div>
            <span className="mr-2">{t("Users_managers.email_validator")}</span>
            {resultsEmailErrors}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const emailExists = () => {
    const resultsEmailErrors = encounterErrorEmailExist.map((results) => (
      <span key={results.rowPosition} className="mr-2">
        {encounterErrorEmailExist.length === 1
          ? `${results.email}, ${t("Users_managers.lines")} : ${
              results.rowPosition
            }`
          : `${results.email},  ${t("Users_managers.line")} : ${
              results.rowPosition
            }`}
      </span>
    ));

    return (
      <div>
        {resultsEmailErrors.length >= 1 ? (
          <div>
            <span className="mr-2">{t("Users_managers.email_exist")}</span>
            {resultsEmailErrors}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const assignedSiteError = () => {
    const resultsAssignedSitesErrors = encounterErrorSites.map((results) => (
      <span key={results.rowPosition} className="mr-2">
        {encounterErrorSites.length === 1
          ? `${results.rowPosition}`
          : `${results.rowPosition},`}
      </span>
    ));

    return (
      <div>
        {resultsAssignedSitesErrors.length >= 1 ? (
          <div>
            <span className="mr-2">
              {t("Users_managers.not_assigned_sites")}
            </span>
            <span>{`${t("Users_managers.line")} : `}</span>
            {resultsAssignedSitesErrors}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const roleError = () => {
    const resultRoleErrors = encounterErrorRoles.map((results) => (
      <span key={`${results.email}${uuidv4()}`} className="mr-2">
        {encounterErrorRoles.length === 1
          ? `${results.rowPosition}`
          : `${results.rowPosition},`}
      </span>
    ));

    return (
      <div>
        {resultRoleErrors.length >= 1 ? (
          <div>
            <span className="mr-2">
              {t("Users_managers.not_completed_roles")}
            </span>
            <span>
              {resultRoleErrors.length === 1
                ? t("Users_managers.line")
                : `${t("Users_managers.line")} : `}
            </span>
            {resultRoleErrors}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <Alert severity="error">
      <div>{emailExists()}</div>

      {tryingToCreateSomething ? (
        <>
          <div>{emailErrors()}</div>
          <div>{assignedSiteError()}</div>
          <div>{roleError()}</div>
        </>
      ) : (
        ""
      )}
    </Alert>
  );
};
